module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_rogaland_neg.ea946817.svg";